"use client";

import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Third-Party Verification",
  description: "Every batch undergoes rigorous HPLC and MS testing by independent laboratories to guarantee absolute purity and sequence accuracy."
}, {
  title: "Cold-Chain Integrity",
  description: "Our temperature-controlled shipping protocols ensure molecular stability and peptide bioactivity from our facility to your laboratory."
}, {
  title: "Surgical-Grade Quality",
  description: "Produced in state-of-the-art facilities following strict quality control measures for uncompromising research reliability."
}, {
  title: "Technical Documentation",
  description: "Full transparency with downloadable Certificates of Analysis (COA) and comprehensive molecular profiles for every product."
}];
export default function WhyChooseFreshness() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="128141" id="why-signal-source-one" className="bg-muted py-12 md:py-20 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {}
          <div className={`flex flex-col space-y-10 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-foreground">
                Why Signal Source One
              </h2>
              <p className="text-lg text-slate-500 max-w-xl leading-relaxed font-light">
                Establishing a new benchmark in biotech research. We combine surgical-grade purity with advanced logistical precision to support your laboratory's most critical studies.
              </p>
            </div>

            <div className="space-y-6">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-start gap-6 group p-4 -m-4 rounded-md hover:bg-white/50 transition-all duration-300">
                  <div className="mt-1 flex-shrink-0 flex items-center justify-center w-14 h-14 rounded-full bg-white shadow-sm ring-1 ring-border group-hover:ring-primary/30 group-hover:shadow-md transition-all duration-300">
                    <CircleCheck className="w-8 h-8 text-primary" />
                  </div>
                  <div className="space-y-1.5">
                    <h3 className="text-xl md:text-2xl font-medium text-foreground tracking-tight group-hover:text-primary transition-colors duration-300">
                      {benefit.title}
                    </h3>
                    <p className="text-base text-slate-500 leading-relaxed font-light">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className={`relative transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-primary/5 blur-[100px] rounded-full pointer-events-none" />

            <div className="relative z-10 rounded-sm overflow-hidden shadow-xl ring-1 ring-border/50 bg-white/50 backdrop-blur-sm p-1">
              <div className="rounded-sm overflow-hidden bg-muted">
                <img src="https://supreme-hookworm.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-Apr-4-2026-04_24_36-PM.png" alt="Clinical-grade laboratory research facility" className="w-full h-auto object-cover aspect-[4/3] hover:scale-105 transition-transform duration-700 ease-in-out" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}